// src/utils/Axios.ts
import axios from "axios";

const Apiaxios = axios.create({
  baseURL: "http://localhost:3000",
  headers: { "Content-Type": "application/json" },
});

export default Apiaxios; // default export
